/**
 * Enum for a time unit (days, weeks, months)
 */
export enum PeriodUnit {
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
}
